import { jsPDF } from 'jspdf'
import font from '@/utils/jspdf/Roboto'

export function importFont(doc: jsPDF): void {
    doc.addFileToVFS('Roboto.ttf', font)
    doc.addFont('Roboto.ttf', 'Roboto', 'normal')
    doc.setFont('Roboto')
}